export function expandTreeItemsToShowSelectedItems(treeItems, selectedItemIds) {
    if (selectedItemIds && selectedItemIds.length > 0) {
        const expandedItemIds = [];
        collectExpandedTreeItemsToShowSelectedItems(treeItems, expandedItemIds, selectedItemIds);
        return expandedItemIds;
    }
    else {
        return [];
    }
}
function collectExpandedTreeItemsToShowSelectedItems(treeItems, expandedItemIds, selectedItemIds) {
    let expandParent = false;
    for (const item of treeItems) {
        if (item.children) {
            if (collectExpandedTreeItemsToShowSelectedItems(item.children, expandedItemIds, selectedItemIds)) {
                if (!expandedItemIds.includes(item.id)) {
                    expandedItemIds.push(item.id);
                }
                expandParent = true;
            }
        }
        if (selectedItemIds.includes(item.id)) {
            expandParent = true;
        }
    }
    return expandParent;
}
